import * as types from './StoreActionTypes';

const initialState = {
    errorMessage: "",
    errorCode: "",
    errorType: "",
    products: [],
    loadedPage: 0,
    totalProducts: 0,
    targetedProduct: 0
};

//-- Process
const setStorePosition = ( state, action ) => {
    const {targetedProduct} = action;
    return {
        ...state,
        targetedProduct
    }
}

//-- XHR receiving datas
const getProducts = ( state, action ) => {
    return{
        ...state,
        products: state.products.concat(action.products),
        totalProducts: action.total,
        loadedPage: action.loadedPage
    };
}

const resetProductsList = (state, action) => {
  return{
    errorMessage: "",
    errorCode: "",
    errorType: "",
    products: [],
    loadedPage: 0,
    totalProducts: 0,
    targetedProduct: 0
  };
}

//-- ERRORS
const receiveError = ( state, action ) => {
    const { errorMessage, errorCode, errorType } = action;
    return{
        ...state,
        errorMessage,
        errorCode,
        errorType
    }
}

const cleanError = ( state, action ) => {
    return{
        ...state,
        errorMessage : "",
        errorCode : "",
        errorType: ""
    }
}


export const datasStore = ( state = initialState, action ) => {
    switch ( action.type ) {
        //-- Process
        case types.SET_POSTION_PRODUCTS:  return setStorePosition( state, action );

        //-- XHR receiving datas
        case types.GET_PRODUCTS:          return getProducts( state, action );
        
        //-- Reset Product list (in order to update list)
        case types.RESET_PRODUCT_LIST:    return resetProductsList(state, action);

        //-- Errors
        case types.CLEAN_ERROR_PRODUCTS:  return cleanError( state, action ); 
        case types.ERROR_PRODUCTS:        return receiveError( state, action ); 
        default:                          return state;
    }
};

export default datasStore;


// WEBPACK FOOTER //
// ./src/components/StorePage/StoreReducers.js